import { z } from '@campai/lib-common/utils/zod'

import { env } from '@/env'

export const getWebAuthProviderConfig = () => {
    const provider = env.VITE_AUTH_PROVIDER
    const result = z
        .object({
            issuer: z.url(),
            clientId: z.string().min(1),
            securitySettingsUrl: z.url(),
        })
        .safeParse(
            provider === 'authy'
                ? {
                      issuer: env.VITE_AUTHY_ISSUER_URL,
                      clientId: env.VITE_AUTHY_CLIENTID,
                      securitySettingsUrl: env.VITE_AUTHY_ISSUER_SECURITY_URL,
                  }
                : {
                      issuer: env.VITE_BLUEID_ISSUER,
                      clientId: env.VITE_BLUEID_CLIENTID,
                      securitySettingsUrl: `${env.VITE_BLUEID_ISSUER}/admin/security`,
                  }
        )

    if (!result.success) {
        const fields = result.error.issues.map(({ path }) => path.join('.')).join(', ')
        throw new Error(`Invalid ${provider} authentication configuration: ${fields}`)
    }

    return { provider, ...result.data }
}
